import { ChangeDetectionStrategy, Component, booleanAttribute, input, model } from '@angular/core';

/**
 * Interrupteur de la maquette, posé sur un `<input type="checkbox">` natif.
 *
 * Une case à cocher reste un vrai contrôle de formulaire : clavier, lecteur
 * d'écran, `disabled`. Le style du rail est de la peinture, pas un bouton
 * maison qui devrait réimplémenter tout cela.
 */
@Component({
  selector: 'ct-switch',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <label class="ct-switch" [class.is-disabled]="disabled()">
      <input
        type="checkbox"
        [checked]="checked()"
        [disabled]="disabled()"
        (change)="onChange($event)"
      />
      <span class="track" aria-hidden="true"></span>
      @if (label(); as text) {
        <span class="caption">{{ text }}</span>
      }
    </label>
  `,
})
export class CtSwitch {
  readonly checked = model(false);
  readonly disabled = input(false, { transform: booleanAttribute });
  readonly label = input('');

  protected onChange(event: Event): void {
    const target = event.target;
    if (target instanceof HTMLInputElement) {
      this.checked.set(target.checked);
    }
  }
}
